var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.maskedValue),expression:"maskedValue"}],staticClass:"input-mascked",attrs:{"placeholder":_vm.placeholder},domProps:{"value":(_vm.maskedValue)},on:{"input":function($event){if($event.target.composing)return;_vm.maskedValue=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }